var _style, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFirmware(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Vectors",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#00038A;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M24,18.9L24,18.9c-0.8,0-1.3,0.5-1.3,1.3v8.5l-3.3-3.3c-0.5-0.5-1.3-0.5-1.9,0c-0.5,0.5-0.5,1.3,0,1.9l0,0 l5.6,5.6c0.3,0.3,0.5,0.4,0.9,0.4s0.7-0.1,0.9-0.4l5.6-5.6c0.5-0.5,0.5-1.3,0-1.9c-0.5-0.5-1.3-0.5-1.9,0l-3.3,3.3v-8.4 C25.3,19.6,24.8,18.9,24,18.9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M41.6,12.5C40.3,4.4,32.5-1.1,24.3,0.4c-3.9,0.7-7.3,2.8-9.5,6.1C8.3,5,1.9,9,0.4,15.5s2.5,12.8,9,14.3 c0.9,0.1,1.6,0.3,2.5,0.3h1.5c0.9,0,1.5-0.6,1.5-1.5s-0.6-1.5-1.5-1.5h-1.5c-4.9,0-9-4.2-8.8-9.1c0-4.9,4.2-9,9.1-8.8 c0.9,0,1.9,0.1,2.8,0.4l1.2,0.4l0.6-1c3.4-5.7,10.7-7.5,16.4-4c3.1,1.9,5.4,5.2,5.7,9l0.1,1l1,0.1c3.3,0.6,5.4,3.6,4.9,6.9 c-0.4,3-3.1,5.1-6.1,4.9h-1.5c-0.9,0-1.5,0.6-1.5,1.5s0.6,1.5,1.5,1.5h1.5c4.9,0,9-4,9-9C47.9,17.1,45.3,13.7,41.6,12.5L41.6,12.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8,43.8c-0.6,0-1,0.4-1,1s0.4,1,1,1h2.1c0,1.1,0.9,2.1,2.1,2.1h8.2c1.1,0,2.1-0.9,2.1-2.1h2.1c0.6,0,1-0.4,1-1 s-0.4-1-1-1h-2.1v-1h2.1c0.6,0,1-0.4,1-1c0-0.6-0.4-1-1-1h-2.1v-1h2.1c0.6,0,1-0.4,1-1c0-0.6-0.4-1-1-1h-2.1c0-1.1-0.9-2.1-2.1-2.1 h-8.2c-1.1,0-2.1,0.9-2.1,2.1h-2.1c-0.6,0-1,0.4-1,1c0,0.6,0.4,1,1,1h2.1v1h-2.1c-0.6,0-1,0.4-1,1c0,0.6,0.4,1,1,1h2.1v1H15.8z  M19.9,37.6h8.2v1l0,0v3.1l0,0v3.1l0,0v1h-8.2V37.6z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1,38.7h-6.2v6.2h6.2V38.7z M25,42.8H23v-2.1H25V42.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirmware);
export default __webpack_public_path__ + "static/media/Firmware.55b42be3977756a67b31b10730ec9152.svg";
export { ForwardRef as ReactComponent };